import { createModule } from '@vue-storefront/core/lib/module'
import { afterRegistration } from './hooks/afterRegistration'

const KEY = 'custom-payments'
export const CustomPayments = createModule({
  key: KEY,
  afterRegistration
})
